import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeHoliday } from '../../redux/actions/holidays';

interface Props {
  match: any;
  handleRemoveHoliday: Function;
}

const Route = ({ match, handleRemoveHoliday }: Props) => (
  <RouteWrapper
    title="Remove Holiday"
    requireAuth
    requirePermission="MANAGE_HOLIDAYS"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Holiday?</Title>
      <Subtitle>
        Once this holiday is removed, you will not be able to view it anymore.
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveHoliday(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Holiday
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/settings/holidays/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveHoliday: (id) => {
    dispatch(removeHoliday(id)).then((response) => {
      if (!response.error) {
        if (!response.error) {
          dispatch(goBack());
          dispatch(goBack());
        } else {
          dispatch(goBack());
        }
      } else {
        if (!response.error) {
          dispatch(goBack());
          dispatch(goBack());
        } else {
          dispatch(goBack());
        }
      }
    });
  },
});

export default connect(() => ({}), mapDispatchToProps)(Route);
